import { useState } from "react";
import { dataWork } from "../Components/Data/dataWork.js";
import WorkCard from "../Components/projects/WorkCard.jsx";

function Work() {
  const [selectedType, setSelectedType] = useState("");

  /**
   * Sets the current selected category of visible works.
   * @param {String} type "", "VFX", or "GFX"
   */
  const handleTypeChange = (type) => {
    setSelectedType(type);
  };

  /**
   * Renders the visible works depending on the selected category
   */
  const renderWorks =
    selectedType === ""
      ? dataWork.map((project, index) => (
          <WorkCard
            title={project.title}
            image={project.image}
            video={project.video}
            genericDescription={project.genericDescription}
            companyDescription={project.companyDescription}
            showType={project.type}
            roles={project.roles}
            id={index}
            key={index}
          />
        ))
      : dataWork
          .filter((filteredProject) => filteredProject.type.includes(selectedType))
          .map((project, index) => (
            <WorkCard
              title={project.title}
              image={project.image}
              video={project.video}
              genericDescription={project.genericDescription}
              companyDescription={project.companyDescription}
              showType={project.type}
              roles={project.roles}
              id={index}
              key={index}
            />
          ));

  return (
    <>
      <h1 className="seo-only">Projects by Final Version 2 Team</h1>
      <h2 className="seo-only">Learn more about the projects that Final Version 2 have worked on.</h2>
      <div className="work">
        <div className="work-page-center">
            <div className="description-section">
              <h2 className="title">Final versions delivered</h2>
              {/* <p className="text">
                Our work ranges from tv shows, films, and documentaries. Here are some of the projects we had fun working on. Contact us to view our reel!
              </p> */}
            </div>

            <div className="gallery-section">
              <div className="gallery-title">
                <div
                  onClick={() => handleTypeChange("")}
                  className={selectedType === "" ? "work-type blue-title" : "work-type"}
                >
                  All
                </div>
                /
                <div
                  onClick={() => handleTypeChange("GFX")}
                  className={selectedType === "GFX" ? "work-type blue-title" : "work-type"}
                >
                  GFX
                </div>
                /
                <div
                  onClick={() => handleTypeChange("VFX")}
                  className={selectedType === "VFX" ? "work-type blue-title" : "work-type"}
                >
                  VFX
                </div>
              </div>

              <div className="gallery">{renderWorks}</div>
            </div>
        </div>
      </div>
    </>
  );
}

export default Work;
